import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from 'app/shared.module';
import { environment } from 'environments/environment';
import { GanttChartModule } from 'smart-webcomponents-angular/ganttchart';

import { StudyGanttChartComponent } from './study-gantt-chart.component';
import { StudyGanttChartLegendComponent } from './study-gantt-chart-legend/study-gantt-chart-legend.component';

window.Smart.License = environment.SMART_LICENSE_KEY;

@NgModule({
  declarations: [StudyGanttChartComponent, StudyGanttChartLegendComponent],
  exports: [StudyGanttChartComponent],
  imports: [BrowserModule, SharedModule, GanttChartModule],
  providers: []
})
export class StudyGanttChartModule {}
